import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PowerBIEmbed } from "@models/powerBIEmbed.model";

export const PowerBIActions = createActionGroup({
  source: 'PowerBI',
  events: {
    'Load PowerBIs': emptyProps(),


    'Get Embed Dashboard Success': props<{ data: PowerBIEmbed}>(),
    'Get Embed Dashboard Failure': props<{ error: string }>(),
    
  }
});
